import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material'
import React, { useState } from 'react'
import { SpocList } from './SpocList';
import AdminList from './AdminList';

export const ViewAdminSpocList = () => {

  const [value, setValue] = useState('admin');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box>
        <TabContext value={value}>
            <Box sx={{ width: '100%', border: "1px solid #E7E7E7", bgcolor: "#F7F8FA" }}>
              <TabList
                value={value}
                onChange={handleChange}
                textColor='#1D3FAA'
                TabIndicatorProps={{
                  sx: {
                    bgcolor: "#1D3FAA"
                  }
                }}
              >
                <Tab sx={{textTransform: "capitalize", fontSize: 17, color: "#1D3FAA", ml: 2}} value="admin" label="Admin" />
                <Tab sx={{textTransform: "capitalize", fontSize: 17, color: "#1D3FAA", ml: 2}} value="spoc" label="Spoc" />
              </TabList>
            </Box>
            <TabPanel value="admin" sx={{py: 0}}>
                <AdminList></AdminList>
            </TabPanel>
            <TabPanel value="spoc" sx={{py: 0}}>
                <SpocList></SpocList>
            </TabPanel>
        </TabContext>
    </Box>
  )
}
